export const ACCESS_TOKEN = 'access_token';

export const LOGIN_PATH = '/login';